<div class="row align-items-center pb-2 flex-row-reverse flex-md-row">
  <div class="col-md-3 mr-auto mb-2 mb-md-0">
      <small class="text-muted" *ngIf="!isSingleSelect"> {{ 'selectedCount' | translate: {count: selectedCountElements} }} </small>
  </div>

  <div>
    <button
      class="cdx-button cdx-button--icon cdx-button--lg mr-1"
      ngbTooltip="{{ 'edit' | translate | titlecase }}"
      *ngIf="enableEditContact && selectedCountElements == 1"
      (click)="editClick()"
    >
      <fa-icon class="fa-fw cdx-button__icon" [icon]="['far','edit']"></fa-icon>
    </button>

    <button
      class="cdx-button cdx-button--icon cdx-button--lg mr-1"
      placement="top-right auto"
      ngbTooltip="{{ 'envelope.signatory.modalAdd.removeSignatoryText' | translate }}"
      *ngIf="selectedCountElements > 0"
      (click)="removeClick()"
    >
      <fa-icon class="fa-fw cdx-button__icon" [icon]="['far','minus-circle']"></fa-icon>
    </button>

    <button
      class="cdx-button cdx-button--icon cdx-button--lg mr-1"
      placement="top-right auto"
      ngbTooltip="{{ 'envelope.signatory.modalAdd.addNewSignatoryText' | translate }}"
      (click)="addClick()"
    >
      <fa-icon class="fa-fw cdx-button__icon" [icon]="['far','plus-circle']"></fa-icon>
    </button>
  </div>

  <cdx-toolbar-search
    (onTyping)="onSearch($event)"
    [value]="searchValue"
    [placeholder]="'search' | translate | titlecase"
    [maxlength]="255"
    [debounceTime]="600"
  >
  </cdx-toolbar-search>
</div>

<div class="scrollable-card-dataTable"
  infiniteScroll
  [infiniteScrollDistance]="2"
  [infiniteScrollThrottle]="50"
  [scrollWindow]="false"
  [infiniteScrollContainer]="'.scrollable-card-dataTable'"
  [fromRoot]="true"
  (scrolled)="onScroll()">

  <table class="table table-hover mb-0 table-box">
    <thead>
      <tr>
        <th
          *ngIf="isSelectable && !isSingleSelect"
          scope="col"
          width="40"
          class="text-center selection-column"
          (click)="onSelectAll()"
          tabindex="0"
          (keyup.enter)="onSelectAll()"
        >
          <div class="d-flex justify-content-left">
            <fa-icon
              class="fa-lg cursor-pointer"
              [icon]="['fal', 'square']"
              *ngIf="!partiallySelected && !allSelected"
            ></fa-icon>
            <fa-icon
              class="fa-lg cursor-pointer"
              [icon]="['fas', 'minus-square']"
              *ngIf="partiallySelected && !allSelected"
            ></fa-icon>
            <fa-icon
              class="fa-lg cursor-pointer"
              [icon]="['fas', 'check-square']"
              *ngIf="allSelected"
            ></fa-icon>
          </div>
        </th>
        <th
          *ngIf="!isSelectable && isSingleSelect"
          scope="col"
          width="40"
          class="text-center selection-column"
        ></th>
        <th>{{ 'name' | translate }}</th>
        <th>{{ 'mail' | translate }}</th>
        <th *ngIf="showSSN">{{ 'ssnUp' | translate }}</th>
        <th *ngIf="showTelephone">{{ 'phone' | translate }}</th>
        <th *ngIf="showSignatureType">{{ 'signatureTypeText' | translate }}</th>
        <th *ngIf="showSubscriberType">{{ 'subscriberTypeText' | translate }}</th>
      </tr>
    </thead>
    <tbody>
      <tr
        class="odd-row"
        *ngFor="let el of elements"
        [class.row-active]="$any(el).checked"
      >
        <td *ngIf="isSelectable && !isSingleSelect" class="selection-column" width="40">
          <div class="d-flex justify-content-left">
            <span
              class="cursor-pointer"
              (click)="onRowClick(el); $event.stopPropagation()"
              tabindex="0"
              (keyup.enter)="onRowClick(el)"
            >
              <fa-icon
                class="fa-lg"
                [icon]="[
                  $any(el).checked ? 'fas' : 'fal',
                  $any(el).checked ? 'check-square' : 'square'
                ]"
              ></fa-icon>
            </span>
          </div>
        </td>
        <td *ngIf="!isSelectable && isSingleSelect" class="selection-column" width="40">
          <div class="d-flex justify-content-left">
            <span
              class="cursor-pointer"
              (click)="onRowClick(el); $event.stopPropagation()"
              tabindex="0"
              (keyup.enter)="onRowClick(el)"
            >
              <fa-icon
                class="fa-lg"
                [icon]="['far', $any(el).checked ? 'dot-circle' : 'circle']"
              ></fa-icon>
            </span>
          </div>
        </td>
        <td>{{ el.name }}</td>
        <td>{{ obfuscateMail(el.mail) }}</td>
        <td *ngIf="showSSN">{{ obfuscateSsn(el.ssn) }}</td>
        <td *ngIf="showTelephone">{{ obfuscateTelephone(el.phoneNumber) }}</td>
        <td *ngIf="showSignatureType">{{ $any(el).signatureType?.value || '' }}</td>
        <td *ngIf="showSubscriberType">
          {{ $any(el).signatoryTypeRole?.isDefault ? ($any(el).signatoryTypeRole?.name | translate) : ($any(el).signatoryTypeRole?.name || '') }}
          <cdx-tag class="ml-2" [options]="inactiveTag" *ngIf="showInactiveTag(el)"></cdx-tag>
        </td>
      </tr>
    </tbody>
  </table>
</div>